module.exports = __webpack_public_path__ + "media/images/home-3-8719e33cb32db613fb40c294d5509fe1.svg";